<mat-dialog-content>
  <div class="header">
    <div class="title">新規作成</div>
  </div>
  <div class="content">
    <div class="form-area">
      <!-- タイトル -->
      <div class="form-row">
        <div class="label">タイトル</div>
        <div class="input-wrapper">
          <div class="char-count" [class.length-red]="isTitleOverLimit">{{ titleLength }}/{{ maxTitleLength }}</div>
          <input
            class="input-text"
            [(ngModel)]="title"
            type="text"
            [maxlength]="maxTitleLength"
            (keydown.enter)="$event.preventDefault()">
        </div>
      </div>

      <!-- カテゴリー -->
      <div class="form-row">
        <div class="label">カテゴリー</div>
        <div class="input-wrapper">
          <mat-select
            class="input-select"
            [(ngModel)]="categoryId">
            @for (cat of categoryOptions; track cat.id) {
              <mat-option [value]="cat.id">{{ cat.name }}</mat-option>
            }
          </mat-select>
          <div class="note">※ 作成後に変更できません。</div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (showSpinner) {
    <mat-spinner diameter="28" class="spinner"></mat-spinner>
  }
  <button mat-flat-button (click)="onCancel()" [disabled]="showSpinner" class="cancel-btn">キャンセル</button>
  <button mat-flat-button (click)="onCreate()" [disabled]="!isCreateButtonEnabled" class="yes-btn">作成</button>
</mat-dialog-actions>
